import Vue from 'vue'
import Vuex from 'vuex'
import alertscreen from './common/alertscreen'
import loading from './common/loading'
import dialogscreen from './common/dialogscreen'
import meta from './common/meta'
import theside from './components/theside'
import account from './common/account'
import condition from './common/condition'
import productcondition from './common/productcondition'
import shopcondition from './common/shopcondition'
import membercondition from './common/membercondition'
import analyzeresult from './result/analyzeresult'
import chartdata from './result/chartdata'
import routerdata from './common/routerdata'
import pagenewslist from './pages/pagenewslist'
import pageaddnews from './pages/pageaddnews'
import pagepassword from './pages/pagepassword'
import pagepasswordinput from './pages/pagepasswordinput'
import pagereservationlist from './pages/pagereservationlist'
import pagebookmarklist from './pages/pagebookmarklist'
import pagehistorylist from './pages/pagehistorylist'
import pagesetting from './pages/pagesetting'
import pagecategorygrouplist from './pages/pagecategorygrouplist'
import pageproductattribute from './pages/pageproductattribute'
import pageproductgrouplist from './pages/pageproductgrouplist'
import pageshopgrouplist from './pages/pageshopgrouplist'
import pagemembergrouplist from './pages/pagemembergrouplist'
import pageuseredit from './pages/pageuseredit'
import pageuserlist from './pages/pageuserlist'
import pagecontractlist from './pages/pagecontractlist'
import pagecontractedit from './pages/pagecontractedit'
import pagedashboard from './pages/pagedashboard'
import pagemanual from './pages/pagemanual'
import pageaccesshistorycondition from './pages/pageaccesshistorycondition'
import pageaccesshistorydetail from './pages/pageaccesshistorydetail'
import pageshopgroupedit from './pages/pageshopgroupedit'
import pageproductgroupedit from './pages/pageproductgroupedit'
import pagecategorygroupedit from './pages/pagecategorygroupedit'
import pageif00014 from './pages/pageif00014'
import pageif00015 from './pages/pageif00015'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    alertscreen,
    loading,
    dialogscreen,
    meta,
    theside,
    account,
    condition,
    productcondition,
    shopcondition,
    membercondition,
    routerdata,
    analyzeresult,
    chartdata,
    pageaddnews,
    pagenewslist,
    pagepassword,
    pagereservationlist,
    pagebookmarklist,
    pagehistorylist,
    pagepasswordinput,
    pagesetting,
    pagecategorygrouplist,
    pageproductattribute,
    pageproductgrouplist,
    pageshopgrouplist,
    pagemembergrouplist,
    pageuseredit,
    pageuserlist,
    pagecontractlist,
    pagecontractedit,
    pagedashboard,
    pagemanual,
    pageaccesshistorycondition,
    pageaccesshistorydetail,
    pageshopgroupedit,
    pageproductgroupedit,
    pagecategorygroupedit,
    pageif00014,
    pageif00015
  }
})
